export const fmtMoney = (n, digits = 0) =>
  n == null || Number.isNaN(Number(n))
    ? "—"
    : Number(n).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: digits,
        minimumFractionDigits: digits,
      });

export const fmtPct = (n, digits = 1) =>
  n == null || Number.isNaN(Number(n)) ? "—" : `${Number(n).toFixed(digits)}%`;

export const num = (v) => {
  const n = parseFloat(String(v).replace(/[^0-9.\-]/g, ""));
  return Number.isNaN(n) ? 0 : n;
};
